<script>
	export let url
	export let alt
	export let size

	let imgSize = {
		TEXT: 'max-w-3xl',
		FULLWIDTH: 'max-w-full'
	}
</script>

<img src={url} {alt} class="{imgSize[size]} my-10" />
